/**
 * Synchronisation du document avec la langue courante (DECISIONS §9.5).
 *
 * `lang` sur `<html>` conditionne la prononciation et la césure ; `title` et `description` sont
 * des textes visibles (onglet, partage) et passent donc par le catalogue, jamais par `index.html`.
 */
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function SynchronisationDocument() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.title = String(t('app.titre'));
    const description = document.querySelector('meta[name="description"]');
    if (description !== null) {
      description.setAttribute('content', String(t('app.description')));
    }
  }, [t, i18n, i18n.language]);

  return null;
}
